import React, { useEffect } from "react";
import { Row, Cell } from "@atlaskit/table-tree";
import { getFlow, getActionName, getAction } from "../../common/utils/integration.util";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Button from "@atlaskit/button/new";
import { triggerByType } from "../../common/utils/trigger";
import "antd/dist/reset.css";
import { Popover } from "antd";
import { TriggerType } from "../../common/interfaces/flow/trigger/TriggerType";
import { getBaseURL, getJiraBaseURL } from "../../env/stage";
import { bytesToSize, formatDate } from "../../common/utils/formatter";
import Lozenge from "@atlaskit/lozenge";

const LogRow = ({ logItem, isGlobal, openDetailsLogview }) => {
  //console.log("Render LogRow")

  const flows = useSelector((state) => state.integration.flows);
  const flow = getFlow(logItem.flowId, flows);
  const actionName = getActionName(logItem.actionId, flow);
  const action = getAction(flow, logItem.actionId);
  const statusText = <div>{logItem.statusText}</div>;

  useEffect(() => {}, [flow, logItem]);

  const getActionTypeIcon = () => {
    return (
      <>
        {action.type === "WEB_REQUEST_ACTION_TYPE" && (
          <span className={"ihub-action-log-list-method " + action.method}>{action.method}</span>
        )}
        {action.type === "SCRIPT_ACTION_TYPE" && <span className="ihub-action-log-list-method scripted">{"</>"}</span>}
      </>
    );
  };

  const triggerInfo = (
    <div className="ihubLogInfoBox">
      {logItem.trigger.type == TriggerType.ATLASSIAN_WEBHOOK_TRIGGER_TYPE && (
        <>
          <p>{logItem.trigger?.config?.jqlFilter}</p>
          <p>{logItem.trigger?.config?.events}</p>
        </>
      )}
      {logItem.trigger.type == TriggerType.CUSTOM_WEBHOOK_TRIGGER_TYPE && (
        <>
          <p>URL:</p>
          <p>
            {getBaseURL()}/incoming/webhook/{logItem.trigger?.value}
          </p>
        </>
      )}
    </div>
  );

  const getLogSize = () => {
    try {
      return JSON.stringify(logItem.response).length;
    } catch (err) {}
    return 0;
  };

  const logSize = getLogSize();

  const renderTriggerLabel = () => {
    const timout = logItem.actionId === "EXECUTION TIMEOUT";
    const startOfFlow = logItem?.startOfFlow ? true : false;
    let displayType = "";

    if (startOfFlow) {
      displayType = "inprogress";
    }
    if (timout) {
      displayType = "removed";
    }
    return <Lozenge appearance={displayType}>{triggerByType(logItem.trigger)}</Lozenge>;
  };

  const isJiraIssueKey = (value) => {
    if (!value || typeof value !== "string") {
      return false;
    }
    return /^[A-Z][A-Z0-9_]*-\d+$/i.test(value.trim());
  };

  const getActionUrl = () => {
    if (actionName && action) {
      return (
        <>
          {getActionTypeIcon()}
          <Link to={`/integration/${logItem.flowId}/action/${logItem.actionId}`}>{actionName}</Link>
        </>
      );
    } else if (logItem.actionId === "EXECUTION TIMEOUT" || logItem.actionId === "EXECUTION MEMORY LIMIT") {
      return <b style={{ color: "red" }}>{logItem.actionId}</b>;
    } else {
      return logItem.actionId + " not found";
    }
  };
  let cells = [
    <Cell key={logItem.id + "1"}>{getActionUrl()}</Cell>,
    <Cell key={logItem.id + "2"}>
      <Popover content={formatDate(logItem.timestamp)} title="Last Run">
        {formatDate(logItem.timestamp)}
      </Popover>
    </Cell>,
    <Cell key={logItem.id + "3"}>
      <Popover content={triggerInfo} title="Trigger Info">
        {renderTriggerLabel()}
      </Popover>
    </Cell>,
    <Cell key={logItem.id + "4"}>
      {logItem.context &&
        (isJiraIssueKey(logItem.context) ? (
          <a href={getJiraBaseURL() + "/browse/" + logItem.context} target="_blank" rel="noreferrer noopener">
            {logItem.context}
          </a>
        ) : (
          <span>{logItem.context}</span>
        ))}
    </Cell>,
    <Cell key={logItem.id + "5"}>
      <Popover content={statusText} title="Status Text">
        {logItem.status}
      </Popover>
    </Cell>,
    <Cell key={logItem.id + "6"}>{logItem.executionTime}</Cell>,
    <Cell key={logItem.id + "7"}>{bytesToSize(logSize)}</Cell>,
    <Cell key={logItem.id + "8"}>
      <Button appearance="subtle" onClick={() => openDetailsLogview(logItem)}>
        View
      </Button>
    </Cell>,
  ];
  if (isGlobal) {
    cells.unshift(
      <Cell key={logItem.id + "8"}>
        <div>
          <Link to={`integration/${logItem.flowId}`}>{flow?.name}</Link>
        </div>
      </Cell>
    );
  }

  return <Row itemId={logItem.id}>{cells}</Row>;
};
export default LogRow;
